<div class="box-container-filter mb-2">
    <dynamic-filter [properties]="dynamicFiltersModel"></dynamic-filter>
</div>
<sit-list-card-audit-page [properties]="gridPageProps"></sit-list-card-audit-page>